import { generateRowId } from '../utils/row-id-utils';
export const COMPONENT_CATALOG = [
    // Layout
    {
        id: 'palette-title-block',
        name: 'Title Block',
        description: 'Title row rendered above column headers, supports {Company} and {Period} tokens',
        category: 'layout',
        defaultRow: { type: 'title_block', id: '', text: 'Report Title', alignment: 'center' },
    },
    {
        id: 'palette-header',
        name: 'Header',
        description: 'Section heading text',
        category: 'layout',
        defaultRow: { type: 'header', id: '', text: 'New Header', level: 1 },
    },
    {
        id: 'palette-column-headers',
        name: 'Column Headers',
        description: 'Repeats the column header row at this position',
        category: 'layout',
        defaultRow: {
            type: 'column_headers',
            id: '',
            columns: [
                { id: '', header: 'Account', type: 'label' },
                { id: '', header: 'Current Period', type: 'current', format: { type: 'currency', decimals: 2, negativeFormat: 'parentheses' } },
            ],
        },
    },
    {
        id: 'palette-line',
        name: 'Line',
        description: 'Horizontal border line between sections',
        category: 'layout',
        defaultRow: { type: 'line', id: '', borderStyle: 'thin' },
    },
    {
        id: 'palette-spacer',
        name: 'Spacer',
        description: 'Empty row for spacing',
        category: 'layout',
        defaultRow: { type: 'spacer', id: '' },
    },
    // Data
    {
        id: 'palette-section',
        name: 'Section',
        description: 'Group of accounts with filter',
        category: 'data',
        defaultRow: {
            type: 'section',
            id: '',
            name: 'New Section',
            filter: {},
            showSubtotal: true,
            subtotalLabel: 'Subtotal',
        },
    },
    {
        id: 'palette-account',
        name: 'Account',
        description: 'Single account line',
        category: 'data',
        defaultRow: { type: 'account', id: '', accountCode: '' },
    },
    {
        id: 'palette-subtotal',
        name: 'Subtotal',
        description: 'Sum of preceding rows',
        category: 'data',
        defaultRow: { type: 'subtotal', id: '', label: 'Subtotal', sumOf: [], style: 'bold' },
    },
    {
        id: 'palette-calculated',
        name: 'Calculated Row',
        description: 'Formula-based row',
        category: 'data',
        defaultRow: { type: 'calculated', id: '', label: 'Calculated', formula: '', style: 'normal' },
    },
    {
        id: 'palette-grandtotal',
        name: 'Grand Total',
        description: 'Final total row',
        category: 'data',
        defaultRow: { type: 'grand_total', id: '', label: 'Grand Total', sumOf: [] },
    },
];
export const COLUMN_TEMPLATES = [
    {
        id: 'tpl-current-only',
        name: 'Current Only',
        columns: [
            { id: '', header: 'Account', type: 'label' },
            { id: '', header: 'Current Period', type: 'current', format: { type: 'currency', decimals: 2, negativeFormat: 'parentheses' } },
        ],
    },
    {
        id: 'tpl-current-vs-prior',
        name: 'Current vs Prior',
        columns: [
            { id: '', header: 'Account', type: 'label' },
            { id: '', header: 'Current Period', type: 'current', format: { type: 'currency', decimals: 2, negativeFormat: 'parentheses' } },
            { id: '', header: 'Prior Period', type: 'prior_period', format: { type: 'currency', decimals: 2, negativeFormat: 'parentheses' } },
            { id: '', header: 'Variance $', type: 'variance_amount', format: { type: 'currency', decimals: 2, negativeFormat: 'parentheses' } },
            { id: '', header: 'Variance %', type: 'variance_percent', format: { type: 'percent', decimals: 1 } },
        ],
    },
    {
        id: 'tpl-budget-vs-actual',
        name: 'Budget vs Actual',
        columns: [
            { id: '', header: 'Account', type: 'label' },
            { id: '', header: 'Actual', type: 'current', format: { type: 'currency', decimals: 2, negativeFormat: 'parentheses' } },
            { id: '', header: 'Budget', type: 'budget', format: { type: 'currency', decimals: 2, negativeFormat: 'parentheses' }, budgetName: '2026 Budget' },
            { id: '', header: 'Variance $', type: 'variance_amount', format: { type: 'currency', decimals: 2, negativeFormat: 'parentheses' } },
            { id: '', header: 'Variance %', type: 'variance_percent', format: { type: 'percent', decimals: 1 } },
        ],
    },
];
export function createRowFromCatalog(catalogId) {
    const item = COMPONENT_CATALOG.find((c) => c.id === catalogId);
    if (!item)
        return null;
    const data = { ...item.defaultRow, id: crypto.randomUUID() };
    if (data.type === 'column_headers') {
        data.columns = data.columns.map((col) => ({ ...col, id: crypto.randomUUID() }));
    }
    return data;
}
export function createNodeFromCatalog(catalogId, existingRowIds) {
    const item = COMPONENT_CATALOG.find((c) => c.id === catalogId);
    if (!item)
        return null;
    const id = crypto.randomUUID();
    const rowId = generateRowId(existingRowIds);
    const data = { ...item.defaultRow, id };
    // Assign fresh UUIDs to columns within column_headers rows
    if (data.type === 'column_headers') {
        data.columns = data.columns.map((col) => ({ ...col, id: crypto.randomUUID() }));
    }
    return {
        id,
        rowId,
        depth: 0,
        columnHeadersId: undefined,
        children: [],
        data,
    };
}
export function createColumnsFromTemplate(templateId) {
    const tpl = COLUMN_TEMPLATES.find((t) => t.id === templateId);
    if (!tpl)
        return [];
    return tpl.columns.map((col) => ({ ...col, id: crypto.randomUUID() }));
}
//# sourceMappingURL=component-catalog.js.map